import React, { Component } from 'react'
import { Button, Card, Col, Row } from 'reactstrap'
import { observer } from 'mobx-react'
import SelectFiltro from '../../comum/components/SelectFiltro'
import { IconeCarregar } from '../../comum/components/Icones'

@observer
export default class FiltroBookingDepot extends Component {

    constructor(props) {
        super(props)

        this.controller = this.props.controller
    }

    componentDidMount() {
        this.controller.listarOperacoes()
    }

    render() {
        return (
            <div className="filtro-card filtros-cabotagem">
                <Card className={`area-form pb-0`}>
                    <Row className="pb-0">
                        <SelectFiltro xs={12} sm={12} md={4} lg={3} xl={2}
                            bloqueado={this.controller.operacoes.length === 0}
                            titulo="Navio/Viagem"
                            itens={this.controller.operacoes}
                            valor={this.controller.opSelecionada}
                            itensValor="value" itensLabel="label"
                            onChange={this.controller.setSelecionarOperacao}
                        />
                        { this.controller.loadingOperacoes && <IconeCarregar tamanho="2x" /> }
                        <Col className="col-botoes" xl={2} lg={3} md={4} sm={12} xs={12}>
                            <Button className="btn-com-bordas-primary btn-filtrar" onClick={this.controller.listarBookings} >Filtrar</Button>
                        </Col>
                    </Row>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/bookingdepot/components/FiltroBookingDepot.js